import { DateField, SelectField, TextField } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const GlobalSearchDesktopTemplates = props => (
  <Fragment>
    <div>
      <TextField name="Description" title={i18n.t('globalSearch:Template Name')} value={props.formData.Description} onChange={props.onFormChange} />
      <TextField name="InvoiceAttention" title={i18n.t('globalSearch:Invoice Attention')} value={props.formData.InvoiceAttention} onChange={props.onFormChange} />
      <SelectField name="SubmissionTypeId" title={i18n.t('globalSearch:Submission Type')} options={props.submissionTypeOptions} value={props.formData.SubmissionTypeId} onChange={props.onFormChange} />
    </div>
    <div>
      <TextField name="ProjectNumber" title={i18n.t('globalSearch:Project #')} value={props.formData.ProjectNumber} onChange={props.onFormChange} />
      <TextField name="ReportAttention" title={i18n.t('globalSearch:Report Attention')} value={props.formData.ReportAttention} onChange={props.onFormChange} />
      <SelectField name="ClientNumber" title={i18n.t('globalSearch:Client')} value={props.formData.ClientNumber} onChange={props.onFormChange} options={props.clientOptions} />
    </div>
    <div>
      <TextField name="SiteLocationOrSiteNumber" title={i18n.t('globalSearch:Site Location / Site #')} value={props.formData.SiteLocationOrSiteNumber} onChange={props.onFormChange} />
      <TextField name="CreatedByName" title={i18n.t('globalSearch:Created By')} value={props.formData.CreatedByName} onChange={props.onFormChange} />
      <SelectField name="DateType" title={i18n.t('globalSearch:Date Type')} value={props.formData.DateType} onChange={props.onFormChange} options={props.dateTypeOptions} />
    </div>
    <div>
      <TextField name="POAFENumber" title={i18n.t('globalSearch:PO #')} value={props.formData.POAFENumber} onChange={props.onFormChange} />
      <TextField name="ModifiedByName" title={i18n.t('globalSearch:Modified By')} value={props.formData.ModifiedByName} onChange={props.onFormChange} />
      <div className="global-search__desktop__container__grid__split">
        <DateField name="DateFrom" title={i18n.t('globalSearch:From')} value={props.formData.DateFrom} onChange={props.onFormChange} />
        <DateField name="DateTo" title={i18n.t('globalSearch:To')} value={props.formData.DateTo} onChange={props.onFormChange} />
      </div>
    </div>
  </Fragment>
);

GlobalSearchDesktopTemplates.propTypes = {
  onFormChange: PropTypes.func,
  formData: PropTypes.shape({
    Description: PropTypes.string,
    InvoiceAttention: PropTypes.string,
    SubmissionTypeId: PropTypes.string,
    ProjectNumber: PropTypes.string,
    ReportAttention: PropTypes.string,
    ClientNumber: PropTypes.string,
    SiteLocationOrSiteNumber: PropTypes.string,
    CreatedByName: PropTypes.string,
    DateType: PropTypes.string,
    POAFENumber: PropTypes.string,
    ModifiedByName: PropTypes.string,
    DateFrom: PropTypes.string,
    DateTo: PropTypes.string,
  }),
  clientOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  submissionTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })),
  dateTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default GlobalSearchDesktopTemplates;



// WEBPACK FOOTER //
// ./src/components/GlobalSearch/GlobalSearchDesktop/GlobalSearchDesktopTemplates/GlobalSearchDesktopTemplates.jsx